module.exports = __webpack_public_path__ + "media/banner-impl.7ae7c9e9.mp4";